<mat-icon [svgIcon]="icon"></mat-icon>
